import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsOptimizedUserTraitsEnabled: () => boolean = () => {
  const { value: isOptimizedUserTraitsEnabled } = useFeatureGate(
    'phx_user_traits_optimization',
  );

  return isOptimizedUserTraitsEnabled;
};
